import { makeStyles } from '@material-ui/core';

export const useRoleItemStyles = makeStyles({
  box: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  guideText: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    '& > p': {
      flex: 1,
    },
  },
});
